import React from 'react'
import './index.scss'
import { useLocation } from 'react-router-dom'
import { ReactComponent as ArrowLeft } from '../../assets/new-icons/arrows.svg'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { MESSAGE_BACK_TO_HOME_MINI_APP } from '../../constants/params'
import { useAppParamsContext } from 'contexts/AppParamsContext'
import BidvArrowLeft from 'assets/icons/icon_ht_arrow-left.png'

export default function HeaderMiniApp({ title, goBack, className, position = 'fixed', shouldPrioritizeGoBack = true }) {
  const { isHeaderMiniAppExpand, appThemeName } = useAppParamsContext()
  const location = useLocation()
  const searchparam = location.search
  const params = new URLSearchParams(searchparam)
  const headerTitle = title || ''
  const history = useHistory()
  const isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1

  const stationThemeName = String(appThemeName || '').toUpperCase()
  const isStationThemeEnabled = ['BIDV'].includes(stationThemeName)

  const ROOT_PATHS = new Set([])

  const handleBack = () => {
    if (goBack && shouldPrioritizeGoBack) {
      goBack()
    } else if (ROOT_PATHS.has(location.pathname)) {
      window.parent.postMessage({ key: MESSAGE_BACK_TO_HOME_MINI_APP }, '*')
    } else if (goBack) {
      goBack()
    } else {
      history.goBack()
    }
  }

  return (
    <div className={`HeaderMiniApp ${'HeaderMiniAppPosition_' + position} ${className || ''} ${isHeaderMiniAppExpand ? 'HeaderMiniApp_expand' : ''} ${isAndroid ? 'is-android' : ''}`}>
      <div className="HeaderMiniApp_fixed">
        {isStationThemeEnabled ? (
          <img src={BidvArrowLeft} alt="Quay lại" className="header-back-icon cursor-pointer" onClick={() => handleBack()} />
        ) : (
          <ArrowLeft onClick={() => handleBack()} />
        )}
        <span>{(headerTitle || '')?.replace(/<[^>]+>/g, '')}</span>
        <div className="no_icon"></div>
      </div>
      <div className="HeaderMiniApp_padding"></div>
    </div>
  )
}

